































import {Component, Vue} from "vue-property-decorator";
import {FreightServiceStore} from "@/modules/freightservices/store";
import {FreightServiceParams} from "@/modules/freightservices/params";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import ServiceTypeLabel from "@/modules/freightservices/List/components/ServiceTypeLabel.vue";
import FreightServiceSearch from "@/modules/freightservices/List/components/Search.vue";
import FreightServiceTableAction from "@/modules/freightservices/List/components/TableAction.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {assignValueToForm} from "@/shared/services/helper/utils";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";

const columns = [
    {
        title: "Thao tác",
        dataIndex: "rowGuid",
        key: "rowGuid",
        scopedSlots: {customRender: 'action'},
        align: 'center',
        width: 100
    },
    {
        title: "Mã dịch vụ",
        dataIndex: "serviceCode",
        key: "serviceCode",
        width: 100,
        ellipsis: true
    },
    {
        title: "Tên dịch vụ",
        dataIndex: "name",
        key: "name",
        ellipsis: true
    },
    {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        scopedSlots: {customRender: 'status'},
        ellipsis: true
    }
];

@Component({
    name: "FreightServiceList",
    components: {FreightServiceTableAction, FreightServiceSearch, ServiceTypeLabel, CommonStatusLabel}
})
export default class extends mixins(CommonMixin) {
    columns = columns;

    created() {
        if (this.isAdmin) {
            this.columns = [
                ...columns,
                {
                    title: "Bưu cục áp dụng",
                    dataIndex: "postOffice.name",
                    key: "postOfficeRowGuid",
                    ellipsis: true
                } as any
            ]
        }

        FreightServiceStore.updateFreightServiceParams(new FreightServiceParams());
        FreightServiceStore.listFreightService({ params: FreightServiceStore.params });
    }

    get freightServices() {
        return FreightServiceStore.freightServices;
    }

    get pagination() {
        return {
            current: FreightServiceStore.meta.page,
            pageSize: FreightServiceStore.meta.limit,
            total: FreightServiceStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} dịch vụ`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        FreightServiceStore.listFreightService({
            params: {
                ...FreightServiceStore.params,
                page: pagination.current,
                limit: pagination.pageSize
            }
        });
    }
}
